import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { tylerConfig } from "./data";

export default function TylerPage() {
  return <CityPageTemplate config={tylerConfig} />;
}